import ReactDOM from "react-dom/client";
import React from "react";
import { Hosting } from "./components/hosting/Hosting";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

const containers = <NodeListOf<HTMLElement>>document.querySelectorAll(".hosting-section");

containers.forEach((container) => {
    const contentElement = container.querySelector(".content");
    const root = ReactDOM.createRoot(contentElement);
    root.render(React.createElement(Hosting, {}));
});
